import { Component, OnInit, OnDestroy, HostBinding, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { Instance } from './models';
import { InstanceService } from './services/instance.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as _ from 'lodash';

@Component({
    standalone: false,
    selector: 'app-instance',
    templateUrl: './instance.component.html',
    styleUrls: ['./instance.component.scss']
})
export class InstanceComponent implements OnInit, OnDestroy {
    constructor(
        private readonly router: Router,
        private readonly instanceService: InstanceService,
        private readonly snackBar: MatSnackBar,
        private readonly changeDetectorRef: ChangeDetectorRef
    ) {}
    searchValue: string = '';

    destroy$ = new Subject<boolean>();

    @HostBinding('class')
    hostClass = 'dashboard';

    instances: Instance[];
    foundInstances: Instance[] = [];

    showSpinner: boolean;

    get areTasksOpened(): boolean {
        return this.router.url === '/instances/tasks';
    }

    get areJobsOpened(): boolean {
        return this.router.url === '/instances/jobs';
    }

    async ngOnInit() {
        this.showSpinner = true;
        this.instanceService.instances
            .pipe(
                takeUntil(this.destroy$),
                filter(instances => instances.length > 0)
            )
            .subscribe(
                instances => {
                    this.instances = instances;
                    this.showSpinner = false;
                    this.search();
                },
                () => {
                    this.showSpinner = false;
                    this.snackBar.open('Can not load Instances', 'OK', {
                        verticalPosition: 'top',
                        horizontalPosition: 'center',
                        duration: 4000
                    });
                }
            );
    }

    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }

    get selectedInstance() {
        return this.instanceService.hasSelectedInstance ? this.instanceService.selectedInstance.Id : -1;
    }

    pickInstance(instance: Instance) {
        this.instanceService.setInstanceById(instance.Id);
    }

    selectTasks(): void {
        this.instanceService.clearCurrentInstance();
    }

    clearSearchValue() {
        this.search('');
    }

    search(value: string = this.searchValue) {
        this.searchValue = value;
        this.foundInstances =
            _.get(this, 'searchValue.length', 0) >= 1
                ? _.get(this, 'instances', []).filter((instance: Instance) =>
                      instance.Name.toLowerCase().startsWith(value.toLowerCase())
                  )
                : this.instances.concat([]);
        this.changeDetectorRef.detectChanges();
    }
}
